import React, { useState } from 'react';
import { TextField } from '@p81-common/ui';
import { IconButton, InputAdornment } from '@mui/material';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';

export interface MaskedTextFieldProps {
  value: string;
  onChange: (value: string) => void;
  label: string;
  placeholder?: string;
  onBlur?: () => void;
  error?: boolean;
  helperText?: string;
  showAriaLabel: string;
  hideAriaLabel: string;
}

const MaskedTextField: React.FC<MaskedTextFieldProps> = ({
  value,
  onChange,
  label,
  placeholder,
  onBlur,
  error,
  helperText,
  showAriaLabel,
  hideAriaLabel
}) => {
  const [showSecret, setShowSecret] = useState(false);

  return (
    <TextField
      type={showSecret ? 'text' : 'password'}
      value={value}
      label={label}
      placeholder={placeholder}
      onChange={e => onChange(e.target.value)}
      onBlur={onBlur}
      error={error}
      helperText={helperText}
      fullWidth
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              aria-label={showSecret ? hideAriaLabel : showAriaLabel}
              onClick={() => setShowSecret(prev => !prev)}
              edge="end"
              size="small"
            >
              {showSecret ? <VisibilityOff /> : <Visibility />}
            </IconButton>
          </InputAdornment>
        )
      }}
    />
  );
};

export default MaskedTextField;
